import { render, staticRenderFns } from "./PermissionCard.vue?vue&type=template&id=049462b2"
import script from "./PermissionCard.vue?vue&type=script&lang=js"
export * from "./PermissionCard.vue?vue&type=script&lang=js"
import style0 from "./PermissionCard.vue?vue&type=style&index=0&id=049462b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports